"use strict";
// keyManager.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAndExtractKeyPair = exports.getPrivateKey = exports.getPublicKey = exports.generateKeys = void 0;
let public_key;
let private_key;
const generateKeys = async () => {
    const data = await (0, exports.generateAndExtractKeyPair)();
    public_key = data.publicKey;
    private_key = data.privateKey;
};
exports.generateKeys = generateKeys;
const getPublicKey = () => public_key;
exports.getPublicKey = getPublicKey;
const getPrivateKey = () => private_key;
exports.getPrivateKey = getPrivateKey;
const arrayBufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
};
const arrayBufferToPEM = (buffer) => {
    let base64 = arrayBufferToBase64(buffer);
    let result = `-----BEGIN PUBLIC KEY-----\n`;
    while (base64.length) {
        result += base64.substring(0, 64) + "\n";
        base64 = base64.substring(64);
    }
    result += `-----END PUBLIC KEY-----\n`;
    return result;
};
const generateAndExtractKeyPair = async () => {
    const algorithm = {
        name: "RSASSA-PKCS1-v1_5",
        modulusLength: 2048,
        publicExponent: new Uint8Array([1, 0, 1]),
        hash: "SHA-256"
    };
    const keyPair = await window.crypto.subtle.generateKey(algorithm, true, // Make the key extractable
    ["sign", "verify"]);
    const spki = await window.crypto.subtle.exportKey("spki", keyPair.publicKey);
    const pemPublicKey = arrayBufferToPEM(spki);
    return { privateKey: keyPair.privateKey, publicKey: pemPublicKey };
};
exports.generateAndExtractKeyPair = generateAndExtractKeyPair;
